// MARK:- Shared inert look fragments and ten-minute session cache for both consumers.
theme.tpmLookSource = {
  async get(url, {cacheContext, signal} = {}) {
    url = new URL(url, window.location.origin);
    const previewTheme = url.searchParams.get('preview_theme_id') ||
      new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    // One bounded entry per tab, shared across homepage and PDPs (including negative matches).
    // Keep prices isolated by customer, B2B location, market, language and currency.
    const storageKey = 'tpm-looks:v1';
    // MARK:- Reuse source fragments, including negative matches, for ten minutes.
    const lifetime = 10 * 60 * 1000;
    const cacheKey = JSON.stringify([url.href, window.Shopify?.theme?.id, cacheContext]);
    const useCache = !previewTheme && !window.Shopify?.designMode && !window.Shopify?.visualPreviewMode &&
      (!window.Shopify?.theme?.role || window.Shopify.theme.role === 'main');
    if (useCache) {
      try {
        const cached = JSON.parse(sessionStorage.getItem(storageKey));
        const age = Date.now() - cached?.createdAt;
        if (cached?.key === cacheKey && age >= 0 && age < lifetime && Array.isArray(cached.looks) &&
            cached.looks.every(look => typeof look.html === 'string' && Array.isArray(look.productIds))) {
          return cached.looks;
        }
      } catch (_) {
        // Disabled storage or a corrupt entry must not prevent normal loading.
      }
    }

    const createdAt = Date.now();
    const response = await fetch(url, {
      signal,
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error(`Shop the Look returned ${response.status}`);
    // Let Shopify's response headers control normal browser caching. Never fall
    // back to an expired session entry if the request fails.
    const source = document.createElement('template');
    source.innerHTML = await response.text();
    const looks = [...source.content.querySelectorAll('[data-tpm-look][data-look-image]')].map(look => {
      look.querySelectorAll('script').forEach(script => script.remove());
      return {
        productIds: [...new Set([...look.querySelectorAll('[data-hotspot-product-id]')]
          .map(button => button.dataset.hotspotProductId))],
        html: look.outerHTML
      };
    }).filter(look => look.productIds.length);

    if (useCache && !signal?.aborted) {
      try {
        sessionStorage.setItem(storageKey, JSON.stringify({key: cacheKey, createdAt, looks}));
      } catch (_) {
        // Storage limits/private browsing only disable this optimization.
      }
    }
    return looks;
  }
};
